import { db } from '../firebase/firebase';
import { setDocentes } from '../reducer/DocentesReducer';

export const loadDocentes = async () => {
    const docentes = [];
    const docentelist = await db.collection('usuariosW')
    .where("rol","==","docente")
    .get();
    docentelist.forEach(snapDocente => {
        docentes.push({
            id: snapDocente.id,
            ...snapDocente.data()
        })
    })
    return docentes;
}

export const startUpdateState = (id, email, state) => {
    return async (dispatch) => {
        await db.collection('usuariosW').doc(email).update({
            state: !state
        });
        const docentes = await loadDocentes();
        dispatch(setDocentes(docentes))
    }
}